var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.componentProps.name))]),_c('div',{staticClass:"blue--text text--darken-4 body-1 pb-3"},[_vm._v(" "+_vm._s(_vm._f("toFullAddress")(_vm.componentProps.address))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }